const Cocurricular = () => {
  return (
    <all>
      <div className="" id="coc">
        {" "}
        <h1 className="flex justify-center text font-hero backfirst text-5xl py-20">
          Co-Curricular
        </h1>
      </div>
      <div className=" flex justify-evenly text font-hero backfirst py-10">
        {" "}
        <h2 className="text-2xl">NOV-2023</h2>
        <p className="text-1xl ">
          <span className="text-2xl">Patent</span>
          <br></br>
          <span className="text-white">
            Implement the idea for creating a volume button in<br></br> wireless
            mouse.
          </span>
        </p>
      </div>
      <div className=" flex justify-evenly text font-hero backfirst py-10">
        {" "}
        <h2 className="text-2xl">NOV-2023</h2>
        <p className="text-1xl ">
        <span className="text-2xl ">PAPER PRESENTATION</span>
          <br></br>
          <span className="text-white">
            National Conference on "Hindustan Institute of Technology" and
            presented a paper titled <br></br>"CHATBOT SONG RECOMMENDATION
            SYSTEM USING API."
          </span>
        </p>
      </div>
      <div className=" flex justify-evenly text font-hero backfirst py-10">
        {" "}
        <h2 className="text-2xl">SEP-2022</h2>
        <p className="text-1xl ">
          <span className="text-2xl">PAPER PRESENTATION</span>
          <br></br>
          <span className="text-white">
            Presented a project titled "SIGNAL AND IMAGE PROCESSOR" at an
            International Conference.<br></br>
          </span>
        </p>
      </div>
      <div className=" flex justify-evenly text font-hero backfirst py-10 ">
        {" "}
        <h2 className="text-2xl ml-8">JAN-2023</h2>
        <p className="text-1xl  ">
          <span className="text-2xl">PRODUCT</span>
          <br></br>
          <span className="text-white typing-demo">
            Filed a product entitled "RICE LEAF DISEASE PREDICTION".
            <br></br>Filed a product entitled "MEETMAX APPLICATION".
          </span>
        </p>
      </div>
    </all>
  );
};
export default Cocurricular;
